import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from '@zaogig/auth';
import { Toaster } from 'sonner';
import { useEffect } from 'react';
import AdminConsole from '../pages/AdminConsole';
import Dashboard from '../pages/Dashboard';
import AdminLayout from '../layouts/AdminLayout';

// ─── 401 listener (global) ────────────────────────
function AuthListener() {
  const navigate = useNavigate();

  useEffect(() => {
    function onAuthFailure() {
      navigate('/login', { replace: true });
    }
    window.addEventListener('zaogig:auth-failure', onAuthFailure);
    return () => window.removeEventListener('zaogig:auth-failure', onAuthFailure);
  }, [navigate]);

  return null;
}

// ─── Login placeholder (can be upgraded later) ────
function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-slate-900">管理后台登录</h1>
        <p className="text-slate-500 mt-2">零工平台管理中心</p>
        <p className="text-slate-400 text-sm mt-8">登录页面开发中...</p>
      </div>
    </div>
  );
}

function WrappedAdminConsole() {
  return (
    <AdminLayout>
      <AdminConsole />
    </AdminLayout>
  );
}

export function App() {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

  return (
    <AuthProvider baseUrl={baseUrl}>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AuthListener />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <WrappedAdminConsole />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
